export enum MemberCardKind {
  SIMPLE,CHAT
}